var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disable},domProps:{"checked":_vm.value},on:{"click":function (e) { return _vm.handleCheck(e); }}}),_vm._v(" "),_c('span',{class:{ 'checkmark': true, 'rounded': _vm.type === 'round', 'disable': _vm.disable }})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b871440","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/remo-checkbox/src/remo-checkbox.vue
// module id = null
// module chunks = 